import { useEffect, useState } from "react";
import api from "../api";

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";

export default function RevenueMultiChannelDashboard() {

  const [data, setData] =
    useState([]);

  const [summary, setSummary] =
    useState({});

  useEffect(() => {
    fetchData();
  }, []);

  // =====================
  // FETCH
  // =====================

  const fetchData = async () => {

    try {

      const res =
        await api.get(
          "/statistiques/revenue-channels"
        );

      setData(
        res.data.channels || []
      );

      setSummary(
        res.data.summary || {}
      );

    } catch (err) {

      console.error(
        "Erreur revenue channels",
        err
      );

    }
  };

  // =====================
  // RENDER
  // =====================

  return (
    <div className="p-3 md:p-6 bg-gray-100 min-h-[100dvh] space-y-4 md:space-y-6">

      {/* HEADER */}
      <h1 className="text-2xl md:text-3xl font-bold">
        📊 Revenus multi-canaux
      </h1>

      {/* KPI */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">

        <Card
          title="Total revenus"
          value={`${summary.total || 0} $`}
        />

        <Card
          title="OTA"
          value={`${summary.ota || 0} $`}
        />

        <Card
          title="Direct"
          value={`${summary.direct || 0} $`}
        />

      </div>

      {/* GRAPH */}
      <div className="bg-white p-3 md:p-5 rounded-2xl shadow">

        <h2 className="mb-4 font-semibold text-base md:text-lg">
          Répartition par canal
        </h2>

        <ResponsiveContainer
          width="100%"
          height={260}
        >

          <BarChart data={data}>

            <XAxis dataKey="channel" />

            <YAxis />

            <Tooltip />

            <Bar dataKey="total" />

          </BarChart>

        </ResponsiveContainer>

      </div>

      {/* TABLE */}
      <div className="bg-white p-3 md:p-5 rounded-2xl shadow">

        <h2 className="mb-4 font-semibold text-base md:text-lg">
          Détails
        </h2>

        <div className="overflow-x-auto">

          <table className="min-w-[500px] w-full text-sm">

            <thead>

              <tr className="text-left border-b bg-gray-50">

                <th className="p-3 whitespace-nowrap">
                  Canal
                </th>

                <th className="p-3 whitespace-nowrap">
                  Réservations
                </th>

                <th className="p-3 whitespace-nowrap">
                  Revenu
                </th>

              </tr>

            </thead>

            <tbody>

              {data.map((row, i) => (

                <tr
                  key={i}
                  className="border-b hover:bg-gray-50 transition"
                >

                  <td className="p-3 whitespace-nowrap">
                    {row.channel}
                  </td>

                  <td className="p-3 whitespace-nowrap">
                    {row.count}
                  </td>

                  <td className="p-3 whitespace-nowrap font-medium">
                    {row.total} $
                  </td>

                </tr>

              ))}

            </tbody>

          </table>

        </div>

      </div>

    </div>
  );
}

function Card({
  title,
  value
}) {

  return (
    <div className="bg-white p-3 md:p-4 rounded-2xl shadow">

      <div className="text-xs md:text-sm text-gray-500">
        {title}
      </div>

      <div className="text-lg md:text-xl font-bold mt-1 break-words">
        {value}
      </div>

    </div>
  );
}